/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "shared": {
                        "nested": {
                          "DeviceProfileTemplateType": {
                            "values": {
                              "DO_NOT_USE": 0,
                              "RST_TABLE_SERVICE": 1,
                              "RST_BAR_OR_LOUNGE": 2,
                              "RST_COUNTER_SERVICE": 3,
                              "RST_DRIVE_THRU_SERVICE": 4
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.shared?.nested?.DeviceProfileTemplateType) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE DeviceProfileTemplateType @ squareup/devicesettings/profiles/v2/model/shared/device_profile_template_type.proto at 9:1
 */
export const DeviceProfileTemplateType = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.shared.DeviceProfileTemplateType').values;